import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import db from "./Firebase"; // Import Firestore instance

const TrackingPage = () => {
    const [userStats, setUserStats] = useState([]);

    useEffect(() => {
        fetchUserAnalytics();
    }, []);

    const fetchUserAnalytics = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, "users_activity"));

            const data = querySnapshot.docs.map((doc) => ({
                user_id: doc.id,
                total_opens: doc.data().total_opens || 0,
                total_duration: doc.data().total_duration || 0,
                last_active: doc.data().last_active || "N/A",
                is_active: doc.data().is_active || false,
                is_inquisitive: doc.data().is_inquisitive || false,
            }));

            setUserStats(data);
        } catch (error) {
            console.error("Error fetching user analytics:", error);
        }
    };

    return (
        <div className="container mt-4">
            <h2>User Analytics</h2>

            <div className="table-responsive">
                <table className="table table-bordered table-hover">
                    <thead className="table-dark">
                        <tr>
                            <th>User ID</th>
                            <th>Total Opens</th>
                            <th>Total Duration (s)</th>
                            <th>Last Active</th>
                            <th>Active (45s+)</th>
                            <th>Inquisitive (2+ Pages)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {userStats.length > 0 ? (
                            userStats.map((user, index) => (
                                <tr key={index}>
                                    <td>{user.user_id}</td>
                                    <td>{user.total_opens}</td>
                                    <td>{user.total_duration}</td>
                                    <td>{user.last_active}</td>
                                    <td>{user.is_active ? "Yes" : "No"}</td>
                                    <td>{user.is_inquisitive ? "Yes" : "No"}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center">
                                    No Data Available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TrackingPage;
